export const setCompany = id => dispatch => {
    dispatch({
      type: 'SET_COMPANY',
      payload: id,
    });
  };